
import { AccountController } from "@/app/ui/controllers/AccountController";
import baggingCombinedForeignAsset from "@/app/ui/assets/svg/scan-flags/bagging_ilust_dg_woodpacking_en.svg";
import baggingWoodpackingForeignAsset from "@/app/ui/assets/svg/scan-flags/bagging_woodpacking_en.svg";
import { Options, Vue, prop } from "vue-class-component";
import { getScanFlags } from "@/domain/entities/ScanFlags";

class Props {
  data = prop<any>({ default: null });
  variant = prop<string>({ default: "sti" });
  flag = prop<string>({ default: "" });
  isStiDest = prop<boolean>({ default: false });
  regionName = prop<string>({ default: "" });
}

@Options({})
export default class ScanFlagIllustration extends Vue.with(Props) {
  get flags() { return getScanFlags(this.data); }
  get isPod() { return /sla hari ini|lewat batas sla|delivery ulang/i.test(this.flag); }
  get isOverdue() { return /lewat batas sla/i.test(this.flag); }
  get flagLabel() {
    if (this.flags.isDangerousGoods && this.flags.isWoodpacking) return this.variant === "bagging" && this.isForeignAccount ? "DANGEROUS GOODS, WOODPACKING" : "DANGEROUS GOODS, PACKING KAYU";
    if (this.flags.isDangerousGoods) return "DANGEROUS GOOD";
    if (this.flags.isWoodpacking) return this.variant === "bagging" && this.isForeignAccount ? "WOODPACKING" : "PACKING KAYU";
    return "";
  }
  get cargoFlagLabel() {
    if (this.flags.isDangerousGoods) return "DG";
    if (this.flags.isWoodpacking) return "KAYU";
    return "";
  }
  get labelClass() {
    if (this.flags.isDangerousGoods) return "scan-flag-dg";
    if (this.flags.isWoodpacking) return "scan-flag-wood";
    return "";
  }
  get stiAsset() {
    return (this.isStiDest || this.isPod)
      ? require("@/app/ui/assets/svg/sti-reverse-scan/icon-sti-dest.svg")
      : require("@/app/ui/assets/svg/sti-reverse-scan/icon-sti.svg");
  }
  get combinedStiAsset() {
    return (this.isStiDest || this.isPod)
      ? require("@/app/ui/assets/svg/scan-flags/sti-dest_dg_woodpacking.svg")
      : require("@/app/ui/assets/svg/scan-flags/sti_dg_woodpacking.svg");
  }
  get isForeignAccount() { return AccountController.accountData.accountIsForeign; }
  get baggingAsset() {
    if (this.flags.isDangerousGoods && this.flags.isWoodpacking)
      return this.isForeignAccount ? baggingCombinedForeignAsset : require("@/app/ui/assets/svg/scan-flags/bagging_ilust_dg_woodpacking.svg");
    if (this.flags.isWoodpacking)
      return this.isForeignAccount ? baggingWoodpackingForeignAsset : require("@/app/ui/assets/svg/scan-flags/bagging_woodpacking.svg");
    return require("@/app/ui/assets/svg/sti-reverse-scan/icon-dangerous-goods.svg");
  }
}
